<template>
  <div class="modal">
    <div class="modal__section">
      <input v-model="price" type="number" class="modal__section-input" />
    </div>

    <div class="modal__buttons">
      <el-button
        type="info"
        class="modal__buttons-item"
        @click="$emit('close')"
      >
        Отмена
      </el-button>

      <el-button type="danger" class="modal__buttons-item" @click="submitForm">
        Сохранить
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoefficientEditModal',
  props: {
    coefficient: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      price: '',
      hasError: false,
    }
  },
  mounted() {
    let parsedPrice = this.coefficient.price_per_ton.split(' ')

    parsedPrice.pop()
    this.price = parsedPrice.join('')
  },
  methods: {
    submitForm() {
      this.$emit('update', { price: this.price, id: this.coefficient.id })
    },
  },
}
</script>

<style lang="sass" scoped>
.modal
  display: flex
  flex-direction: column
  gap: 40px
  &__section
    display: flex
    justify-content: center
    &-input
      width: 180px
      height: 38px
      border: 1px solid #DCDFE6
      border-radius: 4px
      outline: none
      color: #606266
      font-size: 16px
      font-weight: 700
      text-align: center
      &:focus
        border: 1px solid #409EFF
      &::-webkit-outer-spin-button, &::-webkit-inner-spin-button
        -webkit-appearance: none
        margin: 0

    input[type=number]
      -moz-appearance: textfield

  &__buttons
    align-self: center
    display: flex
    gap: 30px
    &-item
      width: 150px
</style>
